<template>
  <div class="main">
    <div>
      <div class="titlefont">
        <div class="titleAnimation">
          <div class="title">
            {{ framework.title }}
          </div>
          <div class="desc">{{ framework.url }}</div>
        </div>
      </div>
      <div class="conMain boxShow">
        <div class="con">
          <div
            class="items"
            v-for="(item, index) in framework.ttitleAndDesc"
            :key="index"
          >
            <div
              class="itemTit"
              :class="{
                active: item.desc.length > 6 && item.desc.length < 13,
                active2: item.desc.length > 12 && item.desc.length <= 18,
                active3: item.desc.length > 18,
              }"
            >
              {{ item.title }}
            </div>
            <ul class="item" :class="{ flex: item.desc.length < 5 }">
              <li v-for="val in item.desc" :key="val">
                {{ val }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    framework: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
